const CopyToClipboard = () => {

    const copyElements = document.getElementsByClassName('copy-text-item-js');

    function copyText(element) {
        const getCopyWrapper = element.getElementsByClassName('copy-text-change-value-js')[0];
        // Pobierz tekst z elementu o ID "text-to-copy"
        var text = element.dataset.textToCopy;
        element.classList.add('copied');

        // Stwórz nowy element <textarea> i umieść tam tekst
        var textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);

        // Zaznacz tekst i wywołaj komendę kopiowania
        textarea.select();
        var successful = document.execCommand("copy");

        // Usuń element <textarea>
        document.body.removeChild(textarea);

        // Zmień tekst przycisku na "Skopiowano", jeśli kopiowanie powiodło się
        if (getCopyWrapper) {
            getCopyWrapper.innerText = "Skopiowano";
            setTimeout(() => {
                getCopyWrapper.innerText = "Kopiuj";
            }, 3000);
        }

        setTimeout(() => {
            element.classList.remove('copied');
        }, 3000);
    }

    if(copyElements) {
        [...copyElements].forEach(element => {
            element.addEventListener("click", function () {
                copyText(this);
            });
            element.addEventListener("touchend", function () {
                copyText(this);
            });
        });
    }


}

export default CopyToClipboard;